import { createContext } from 'react';

const DimensionContext = createContext({});

export default DimensionContext;
